import PropTypes from 'prop-types';
import { intlMessageShape } from './intlMessageShape';
export var linkPropTypes = {
  label: intlMessageShape.isRequired,
  onClick: PropTypes.func,
  href: intlMessageShape
};
export var linkShape = PropTypes.shape(linkPropTypes);